export const FILTER_PARAMS = {
  dr: 'dr',
  makeModel: 'ms',
  mileage: 'ml',
  price: 'p',
  payment: 'payment',
  frequency: 'frequency',
} as const;
